<script lang="ts" setup>
import CustomModalWindow from '~/components/modal-windows/CustomModalWindow.vue'
import PickUpPointNotification from '~/components/modal-windows/shipping/PickUpPointNotification.vue'
import constants from '~/constants'
import OrderShippingType from '~/enums/order-shipping-type'
import { useCartStore } from '~/store/cart'

const model = defineModel<boolean>()

const messages = { failedToCalculateShippingCost: 'Не удалось рассчитать стоимость доставки.' }

const cartStore = useCartStore()

const { $apiHelper, $toast } = useNuxtApp()

const errorMessage = ref<string | null>(null)
const fivePostPickUpPointId = ref<string | null>(null)
const fivePostWidget = ref<any>(null)
const scriptElement = ref<HTMLScriptElement | null>(null)
const shippingCostInKopecks = ref<number | null>(null)

function close (): void {
  model.value = false
}

function closed (): void {
  if (fivePostWidget.value) {
    fivePostWidget.value.destroy()
  }

  (scriptElement.value as HTMLScriptElement).parentNode?.removeChild(scriptElement.value as HTMLScriptElement)
}

async function getShippingCost (): Promise<void> {
  try {
    const { meta } = await $apiHelper.actions.getShippingCost(
      OrderShippingType.FivePostPickUpPoint,
      cartStore.weightInGrams as number,
      { pickUpPointId: fivePostPickUpPointId.value }
    ) as any
    errorMessage.value = meta.errorMessage
    shippingCostInKopecks.value = meta.shippingCostInKopecks
  } catch (error) {
    console.error(error)

    $toast.error(messages.failedToCalculateShippingCost)
  }
}

function opened (): void {
  const _scriptElement = document.createElement('script')
  _scriptElement.async = true
  _scriptElement.onload = (): void => {
    fivePostWidget.value = new (window as any).fivepost.PickupPointsMap({
      apikey: constants.fivePostWidgetApiKey,
      target: '#map',
      onSelectPoint: async (result: any): Promise<void> => {
        console.log('5Post', result)

        errorMessage.value = null

        const { id: pickUpPointId, resultAddress: fullAddress } = result

        fivePostPickUpPointId.value = pickUpPointId

        if (cartStore.isFreeShippingEnabled) {
          shippingCostInKopecks.value = 0
        } else if (cartStore.fixedShippingCostInKopecks !== null) {
          shippingCostInKopecks.value = cartStore.fixedShippingCostInKopecks
        } else {
          await getShippingCost()
        }

        if (shippingCostInKopecks.value !== null) {
          cartStore.shippingCostInKopecks = shippingCostInKopecks.value
          cartStore.shippingData = { fullAddress, pickUpPointId }

          close()
        }
      },
      onLoadYandexApi: (): void => {
        console.log('onLoadYandexApi')
      },
      onInit: (): void => {
        console.log('onInit')
      },
      onCancel: (result: any): void => {
        console.log('canceled', result)
      }
    })
  }
  _scriptElement.src = 'https://fivepost.ru/static/5post-widget-v1.0.js'
  scriptElement.value = _scriptElement
  document.getElementsByTagName('head')[0].appendChild(_scriptElement)
}
</script>

<template>
  <CustomModalWindow v-model="model" size="large" @closed="closed" @opened="opened">
    <template #title>
      Выбор пункта выдачи заказов&nbsp;— 5Post
    </template>

    <Notification v-if="errorMessage" class="mb-6" is-small status="error">
      {{ errorMessage }}
    </Notification>

    <PickUpPointNotification class="mb-6" />

    <div class="five-post-map-area mb-6">
      <div id="map" class="bg-white" />
    </div>

    <template #action>
      <a href="#" @click.prevent="close">Закрыть</a>
    </template>
  </CustomModalWindow>
</template>

<style lang="scss" scoped>
#map {
  height: 100%;
  width: 100%;
}
.five-post-map-area {
  background: #f2f2f3;
  height: 560px;
}
</style>
